import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipWalletComponent } from './payment-sip-wallet.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [PaymentSipWalletComponent],
  exports: [PaymentSipWalletComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class PaymentSipWalletModule { }
